import { render, staticRenderFns } from "./AboutScreen.vue?vue&type=template&id=f946dac0"
import script from "./aboutScreen.ts?vue&type=script&lang=js&external"
export * from "./aboutScreen.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports